export const CHECKOUT_URL = 'https://clinic.impultienda.ar/checkout';

export const MOCKUP_IMAGE =
  'https://cdn.magicpatterns.com/uploads/6eSZqD6WhBMSbh3bYhGaT6/ANTICOAGULACION.png';

export const stats = [
  { value: '+300', label: 'Clinical tools included' },
  { value: '+1,200', label: 'Dentists using it' },
  { value: '2,400+', label: 'Hours of uncertainty eliminated' },
  { value: '97%', label: 'Would recommend it' },
];

export const beforeItems = [
  'You accept cases without full clarity',
  'You hesitate when defining VDO',
  'You rely on intuition instead of a system',
  'You fear remakes and complications',
  'You undercharge because you lack confidence',
  'You overthink every complex case',
];

export const afterItems = [
  'You follow a structured diagnostic system',
  'You define VDO with objective criteria',
  'You make faster, more confident decisions',
  'You validate each phase before final delivery',
  'You present high-value cases with authority',
  'You walk into every case with a clear plan',
];

export const painPoints = [
  { emoji: '😰', text: 'You see severe wear cases and don’t know where to start' },
  { emoji: '⏱️', text: 'You spend hours reviewing notes before planning' },
  { emoji: '🤷', text: 'You’re unsure when patients ask “Will it last?”' },
  { emoji: '💸', text: 'You could charge more… but don’t feel confident enough' },
  { emoji: '😓', text: 'You’ve had failures or remakes that shook your confidence' },
  { emoji: '😩', text: 'You refer cases you could actually handle yourself' },
  { emoji: '🔴', text: 'You define VDO based on intuition — not a repeatable method' },
];

export const volumes = [
  {
    number: 'Volume 1',
    title: 'Binary Decision Algorithm™',
    subtitle: 'The Pre-Clinical Risk Filter',
    description:
      'Quickly determine if a case is safe, risky, or should be rejected—before you even start.',
  },
  {
    number: 'Volume 2',
    title: 'Vertical Dimension & Occlusion Mastery',
    subtitle: 'Recover Lost Space With Precision',
    description:
      'Know exactly when, how, and how much to increase VDO using repeatable criteria.',
  },
  {
    number: 'Volume 3',
    title: 'Functional Smile Architecture™',
    subtitle: 'Design Smiles That Actually Last',
    description:
      'Combine esthetics and function to create long-term stable rehabilitations.',
  },
  {
    number: 'Volume 4',
    title: 'Treatment Sequencing Protocol',
    subtitle: 'What to Do First (And Why It Matters)',
    description:
      'Eliminate guesswork and reduce adjustments with a structured clinical roadmap.',
  },
  {
    number: 'Volume 5',
    title: 'Clinical Rescue Manual',
    subtitle: 'Fix Problems Without Panic',
    description:
      'Handle fractures, discomfort, or complications with clear recovery protocols.',
  },
  {
    number: 'Volume 6',
    title: 'High-Value Case Presentation System',
    subtitle: 'Turn Diagnosis Into Accepted Treatment Plans',
    description:
      'Communicate with clarity so patients understand—and accept—your treatment.',
  },
];

export const instantItems = [
  { emoji: '📘', text: 'Full 6-volume system' },
  { emoji: '📝', text: 'Binary Decision Algorithm' },
  { emoji: '🦷', text: 'Clinical Traffic Light System (Green / Yellow / Red)' },
  { emoji: '🗂️', text: 'VDO & Occlusion Protocols' },
  { emoji: '🔬', text: 'Functional Smile Design Guide' },
  { emoji: '⚙️', text: 'Clinical Complication Manual' },
];

export const bonuses = [
  {
    emoji: '🏆',
    title: 'Bonus #1 — 50 Master Clinical Cases',
    description: 'See exactly how complex cases are diagnosed and solved step by step.',
    highlight: 'Stop guessing. Start modeling proven decisions.',
    value: '$47',
    image: 'https://cdn.magicpatterns.com/uploads/wcYjPA1oYJ82q2UaRKDg3T/BONUS_1_CLINICAL.png',
  },
  {
    emoji: '⚡',
    title: 'Bonus #2 — 10-Minute Diagnosis Protocol™',
    description: 'A rapid system to identify risk, viability, and direction in minutes.',
    highlight: 'Walk into any case with immediate clarity.',
    value: '$37',
    image: 'https://cdn.magicpatterns.com/uploads/9ZSgVMz4vfA2q77UGcNiFv/BONUS_2_CLINICAL.png',
  },
  {
    emoji: '🔴',
    title: 'Bonus #3 — Clinical Mistakes Library',
    description: 'The real reasons restorations fail—so you never repeat them.',
    highlight: 'Avoid fractures, debonds, and costly remakes.',
    value: '$47',
    image: 'https://cdn.magicpatterns.com/uploads/mgFrcqkYcmo8wALDLNdNM5/BONUS_3_CLINICAL.png',
  },
  {
    emoji: '💬',
    title: 'Bonus #4 — High-Ticket Case Scripts',
    description: 'Exact words to present treatment and handle price objections.',
    highlight: 'Increase acceptance without sounding “salesy.”',
    value: '$37',
    image: 'https://cdn.magicpatterns.com/uploads/8YynuDFHf3ae8Uc4dZQMSv/BONUS_4_CLINICAL.png',
  },
  {
    emoji: '✅',
    title: 'Bonus #5 — 30 Clinical Checklists Pack',
    description: 'Step-by-step checklists for every stage of treatment.',
    highlight: 'Never miss a critical detail again.',
    value: '$29',
    image: 'https://cdn.magicpatterns.com/uploads/dTPbCjQX2Ydmj8Bss8SrtZ/BONUS_5_CLINICAL.png',
  },
];

export const testimonials = [
  {
    quote:
      'I finally have a clear system for VDO. I already accepted cases I used to refer.',
    name: 'Maria L.',
    country: 'Colombia',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/8eea7455-55f8-4e81-bdc8-0420dee02a72.jpg',
  },
  {
    quote: 'The Clinical Rescue Manual alone saved me from a major remake.',
    name: 'Jorge R.',
    country: 'Mexico',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/7fd7559f-cec8-45d5-b695-d3fba516defe.jpg',
  },
  {
    quote:
      'My treatment acceptance increased because I now explain cases with confidence.',
    name: 'Andrea P.',
    country: 'Venezuela',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/64410c40-277b-4a42-a49b-e02d0a3e524b.jpg',
  },
  {
    quote: 'The checklists changed everything. I feel in control of every step.',
    name: 'Carlos S.',
    country: 'Spain',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/e48290af-d48f-416c-b7e8-809b05762d6b.jpg',
  },
];

export const faqs = [
  {
    question: 'How do I access the material?',
    answer: 'Instant download after purchase. No waiting.',
  },
  {
    question: 'Is it a subscription?',
    answer: 'No. One-time payment. Lifetime access.',
  },
  {
    question: 'Do I need to be a specialist?',
    answer: 'No. Designed for general dentists and restorative clinicians.',
  },
  {
    question: 'Is it PDF?',
    answer: 'Yes. High-quality, printable and mobile-friendly.',
  },
  {
    question: 'What if it’s not for me?',
    answer: 'You have 7 days to request a full refund.',
  },
];

export const purchaseNotifications = [
  { name: 'Dr. Valentina G.', place: 'Bogotá, Colombia' },
  { name: 'Dr. Richard M.', place: 'Manchester, United Kingdom' },
  { name: 'Dr. Camila R.', place: 'Santiago, Chile' },
  { name: 'Dr. Sebastian O.', place: 'Buenos Aires, Argentina' },
  { name: 'Dr. Lucia F.', place: 'Madrid, Spain' },
  { name: 'Dr. Andrew T.', place: 'Toronto, Canada' },
  { name: 'Dr. Paola V.', place: 'Quito, Ecuador' },
  { name: 'Dr. Michael A.', place: 'Houston, United States' },
  { name: 'Dr. Daniela C.', place: 'Montevideo, Uruguay' },
  { name: 'Dr. Emma H.', place: 'Sydney, Australia' },
  { name: 'Dr. Gabriela S.', place: 'San José, Costa Rica' },
  { name: 'Dr. Julian P.', place: 'Dublin, Ireland' },
];
